import React, {useEffect, useState} from 'react';
import {
    getClientWebChatConf,
    updateClientWebChatColorsConf,
    updateClientWebChatConf
} from "../../../../../../services/company/api";
import WebChatStyles from "../webchat-conf/WebChatStyles";
import config from "../../../../../../config";
import {tabButtonStyles} from "../../../../../../utils/General";
import Translate from "../../../../../../components/Translate";


const styles = {
    title: {
        fontSize: '18px',
        padding: '20px 40px',
        color: '#A4ADC1',
        marginBottom: '15px'
    },
    sectionTitle: {
        fontSize: '16px',
        color: '#A4ADC1',
    },
    bottomMargin: {
        marginBottom: '20px',
    },
};


const Design = ({client, tariff}) => {
    const {features} = tariff;
    let mainPage;
    if (features.includes(config.features.CUSTOMIZE_WEBCHAT_COLORS)) {
        mainPage = 'colors'
    } else if (features.includes(config.features.CUSTOMIZE_WEBCHAT)) {
        mainPage = 'main'
    }
    const [loading, setLoading] = useState(true);
    const [id, setId] = useState('');
    const [colors, setColors] = useState({
        headerBackground: '',
        bodyBackground: '',
        botMessageBackground: '',
        userMessageBackground: '',
        footerBackground: '',
        botTextColor: '',
        userTextColor: '',
        quickReplyTextColor: '',
        isCompleted: false,
    });
    const [texts, setTexts] = useState({
        isCompleted: false
    });
    const [menuItems, setMenuItems] = useState()
    const [startInputs, setStartInputs] = useState()
    const [poweredByConfig, setPoweredByConfig] = useState(true);
    const [operatorPhotoInChat, setOperatorPhotoInChat] = useState(true);
    const [endButton, setEndButton] = useState(true);
    const [startInputsEnabled, setStartInputsEnabled] = useState(false);
    const [typingIndicatorEnabled, setTypingIndicatorEnabled] = useState(true);
    const [seenIndicatorEnabled, setSeenIndicatorEnabled] = useState(true);

    const [activeTab, setActiveTab] = useState(mainPage);

    useEffect(() => {
        getClientWebChatConf(client.id).then((data) => {
            setLoading(false);
            setId(data.id);
            setColors({...data.colors, isCompleted: true});
            setTexts({...data.texts, isCompleted: true});
            setMenuItems(data.menuItems)
            setStartInputs(data.startInputs)
            setPoweredByConfig(data.poweredByEnabled)
            setTypingIndicatorEnabled(data.typingIndicatorEnabled)
            setSeenIndicatorEnabled(data.seenIndicatorEnabled)
            setOperatorPhotoInChat(data.operatorPhotoInChat)
            setEndButton(data.endButtonEnabled)
            setStartInputsEnabled(data.startInputsEnabled)
        });
    }, [client.id]);

    const saveColors = (updateData) => {
        const updatedColors = {...colors, ...updateData};
        updateClientWebChatColorsConf(id, updatedColors).then(() => {
            setColors(updatedColors);
        });
    }

    const saveMenuItemConfig = (field, data) => {
        setMenuItems(prev => {
            const updated = { ...prev, [field]: data };

            const newData = {
                texts,
                poweredByEnabled: poweredByConfig,
                typingIndicatorEnabled,
                seenIndicatorEnabled,
                operatorPhotoInChat,
                endButtonEnabled: endButton,
                startInputsEnabled,
                menuItems: updated,
                startInputs
            };

            updateClientWebChatConf(id, newData).then(() => {});
            return updated;
        });
    }

    const savePoweredByConfig = (data) => {
        const newData = {
            texts,
            poweredByEnabled: data,
            typingIndicatorEnabled,
            seenIndicatorEnabled,
            operatorPhotoInChat,
            startInputsEnabled,
            menuItems,
            startInputs,
            endButtonEnabled: endButton
        };
        updateClientWebChatConf(id, newData).then(() => {
            setPoweredByConfig(data);
        });
    }

    const saveTypingIndicatorConfig = (data) => {
        const newData = {
            texts,
            poweredByEnabled: poweredByConfig,
            typingIndicatorEnabled: data,
            seenIndicatorEnabled,
            operatorPhotoInChat,
            startInputsEnabled,
            menuItems,
            startInputs,
            endButtonEnabled: endButton
        };
        updateClientWebChatConf(id, newData).then(() => {
            setTypingIndicatorEnabled(data);
        });
    }

    const saveSeenIndicatorConfig = (data) => {
        const newData = {
            texts,
            poweredByEnabled: poweredByConfig,
            typingIndicatorEnabled,
            seenIndicatorEnabled: data,
            operatorPhotoInChat,
            startInputsEnabled,
            menuItems,
            startInputs,
            endButtonEnabled: endButton
        };
        updateClientWebChatConf(id, newData).then(() => {
            setSeenIndicatorEnabled(data);
        });
    }

    const saveOperatorPhotoInChat = (data) => {
        const newData = {
            texts,
            poweredByEnabled: poweredByConfig,
            operatorPhotoInChat: data,
            typingIndicatorEnabled,
            seenIndicatorEnabled,
            startInputsEnabled,
            menuItems,
            startInputs,
            endButtonEnabled: endButton
        };
        updateClientWebChatConf(id, newData).then(() => {
            setOperatorPhotoInChat(data);
        });
    }

    const saveEndButton = (data) => {
        const newData = {
            texts,
            poweredByEnabled: poweredByConfig,
            operatorPhotoInChat: operatorPhotoInChat,
            typingIndicatorEnabled,
            seenIndicatorEnabled,
            startInputsEnabled,
            menuItems,
            startInputs,
            endButtonEnabled: data
        };
        updateClientWebChatConf(id, newData).then(() => {
            setEndButton(data);
        });
    }

    const saveStartInputsConfig = (data) => {
        const newData = {
            texts,
            poweredByEnabled: poweredByConfig,
            operatorPhotoInChat: operatorPhotoInChat,
            typingIndicatorEnabled,
            seenIndicatorEnabled,
            startInputsEnabled: data,
            menuItems,
            startInputs,
            endButtonEnabled: endButton
        };
        updateClientWebChatConf(id, newData).then(() => {
            setStartInputsEnabled(data);
        });
    }

    const saveStartInputConfig = (field, data) => {
        setStartInputs(prev => {
            const updated = { ...prev, [field]: data };

            const newData = {
                texts,
                poweredByEnabled: poweredByConfig,
                typingIndicatorEnabled,
                seenIndicatorEnabled,
                operatorPhotoInChat,
                startInputsEnabled,
                menuItems,
                startInputs: updated,
                endButtonEnabled: endButton
            };

            updateClientWebChatConf(id, newData).then(() => {});
            return updated;
        });
    };

    const saveTexts = (updateData) => {
        const updatedTexts = {...texts, ...updateData};
        const data = {
            texts: updatedTexts,
            poweredByEnabled: poweredByConfig,
            typingIndicatorEnabled,
            seenIndicatorEnabled,
            operatorPhotoInChat: operatorPhotoInChat,
            startInputsEnabled,
            menuItems,
            startInputs,
            endButtonEnabled: endButton
        };

        updateClientWebChatConf(id, data).then(() => {
            setTexts(updatedTexts);
        });
    }

    return (
        <div>

            <div style={tabButtonStyles.tabButtons}>

                {features.includes(config.features.CUSTOMIZE_WEBCHAT_COLORS) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'colors')}
                            onClick={() => setActiveTab('colors')}>
                        <Translate text="colors"/>
                    </button>
                )}

                {features.includes(config.features.CUSTOMIZE_WEBCHAT) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'main')}
                            onClick={() => setActiveTab('main')}>
                        <Translate text="main"/>
                    </button>
                )}

                {features.includes(config.features.CUSTOMIZE_WEBCHAT) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'menu')}
                            onClick={() => setActiveTab('menu')}>
                        <Translate text="menu"/>
                    </button>
                )}

                {features.includes(config.features.CUSTOMIZE_WEBCHAT) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'startInputs')}
                            onClick={() => setActiveTab('startInputs')}>
                        <Translate text="startInputs"/>
                    </button>
                )}

                {features.includes(config.features.CUSTOMIZE_WEBCHAT) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'notifications')}
                            onClick={() => setActiveTab('notifications')}>
                        <Translate text="notifications"/>
                    </button>
                )}

            </div>

            {colors.isCompleted &&
                <WebChatStyles commonStyles={styles}
                               activeTab={activeTab}
                               features={features}
                               texts={texts}
                               menuItems={menuItems}
                               startInputs={startInputs}
                               setStartInputs={setStartInputs}
                               setMenuItems={setMenuItems}
                               colors={colors}
                               poweredByConfig={poweredByConfig}
                               typingIndicatorEnabled={typingIndicatorEnabled}
                               seenIndicatorEnabled={seenIndicatorEnabled}
                               operatorPhotoInChat={operatorPhotoInChat}
                               endButton={endButton}
                               startInputsEnabled={startInputsEnabled}
                               savePoweredByConfig={savePoweredByConfig}
                               saveTypingIndicatorConfig={saveTypingIndicatorConfig}
                               saveSeenIndicatorConfig={saveSeenIndicatorConfig}
                               saveOperatorPhotoInChat={saveOperatorPhotoInChat}
                               saveEndButton={saveEndButton}
                               saveStartInputsConfig={saveStartInputsConfig}
                               saveStartInputConfig={saveStartInputConfig}
                               saveTexts={saveTexts}
                               saveColors={saveColors}
                               saveMenuItemConfig={saveMenuItemConfig}
                />
            }
        </div>
    );
};

export default Design;


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/Design.jsx